export const homeIconData = { id: 1, masterId: 0 };